import React, { useEffect, useState } from 'react';
import { Users, DollarSign, Image, Activity } from 'lucide-react';

const CreatorHome = () => {
    const [user, setUser] = useState(null);
    const [stats, setStats] = useState({
        totalSets: 0,
        totalViews: 0,
        referralCount: 0,
        totalRevenue: 0,
        loading: true
    });

    useEffect(() => {
        const stored = localStorage.getItem('paradise_user');
        if (stored) {
            const userData = JSON.parse(stored);
            setUser(userData);
            fetchStats(userData);
        }
    }, []);

    const fetchStats = async (userData) => {
        const token = localStorage.getItem('paradise_token');
        const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000';

        try {
            // Fetch Sets
            const setsRes = await fetch(`${API_BASE}/api/sets`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const setsData = await setsRes.json();

            // Fetch Referrals/Revenue
            const refRes = await fetch(`${API_BASE}/api/creator/referrals`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const refData = await refRes.json();

            setStats({
                totalSets: setsData.length || 0,
                totalViews: 0, // Placeholder for now
                referralCount: refData.count || 0,
                totalRevenue: refData.totalRevenue || 0,
                loading: false
            });
        } catch (error) {
            console.error('Fetch Stats Error:', error);
            setStats(prev => ({ ...prev, loading: false }));
        }
    };

    return (
        <div>
            <h2 className="text-2xl font-bold mb-6 italic uppercase tracking-widest font-mono">Welcome back, {user?.name || user?.email}</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex items-start justify-between">
                    <div>
                        <h3 className="text-gray-400 text-[10px] font-bold uppercase tracking-widest mb-2">Total Sets</h3>
                        <p className="text-3xl font-bold font-mono">{stats.totalSets}</p>
                    </div>
                    <div className="p-2 bg-zinc-50 rounded-lg">
                        <Image size={20} className="text-zinc-400" />
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex items-start justify-between">
                    <div>
                        <h3 className="text-gray-400 text-[10px] font-bold uppercase tracking-widest mb-2">Earnings</h3>
                        <p className="text-3xl font-bold font-mono text-emerald-600">${stats.totalRevenue.toFixed(2)}</p>
                    </div>
                    <div className="p-2 bg-emerald-50 rounded-lg">
                        <DollarSign size={20} className="text-emerald-600" />
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex items-start justify-between">
                    <div>
                        <h3 className="text-gray-400 text-[10px] font-bold uppercase tracking-widest mb-2">Referrals</h3>
                        <p className="text-3xl font-bold font-mono text-blue-600">{stats.referralCount}</p>
                    </div>
                    <div className="p-2 bg-blue-50 rounded-lg">
                        <Users size={20} className="text-blue-600" />
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex items-start justify-between">
                    <div>
                        <h3 className="text-gray-400 text-[10px] font-bold uppercase tracking-widest mb-2">Portal Status</h3>
                        <p className="text-sm font-bold bg-zinc-900 text-white inline-block px-3 py-1 rounded uppercase tracking-tighter mt-2">Verified</p>
                    </div>
                    <div className="p-2 bg-zinc-50 rounded-lg">
                        <Activity size={20} className="text-zinc-400" />
                    </div>
                </div>
            </div>

            {/* Quick Actions or Recent Feedback could go here */}
            <div className="bg-zinc-900 p-8 rounded-2xl text-white relative overflow-hidden">
                <div className="relative z-10">
                    <h3 className="text-2xl font-bold mb-2 tracking-tight italic">Generation Update</h3>
                    <p className="text-zinc-400 text-sm max-w-md mb-6 inline-block">Revenue is calculated based on active memberships and past billing cycles. Payouts are processed via PayPal on the 1st of every month.</p>
                </div>
                <div className="absolute right-[-20px] bottom-[-20px] opacity-10">
                    <DollarSign size={200} />
                </div>
            </div>
        </div>
    );
};

export default CreatorHome;
